import { useTranslation } from 'libs/i18n'
import { ContextMenu } from 'shared/components'
import { Detail } from 'shared/atoms'
import type { Option } from 'shared/components/ContextMenu/types'
import type { CategoryItem } from '../../types/categories.types'

export type CategoryProps = {
	category: CategoryItem
	menuOptions: Option[]
}

export const Category = ({ category, menuOptions }: CategoryProps) => {
	const { t } = useTranslation()

	return (
		<li className="p-4">
			<div className="flex items-start justify-between gap-3">
				<p className="min-w-0 text-[13px] font-semibold text-foreground">{category.name}</p>
				<ContextMenu
					dataId={category.id}
					item={category}
					options={menuOptions}
					label={t('Actions for {{ name }}', { name: category.name })}
				/>
			</div>
			<dl className="mt-2 grid grid-cols-2 gap-x-4 gap-y-2 text-[11px]">
				<Detail label={t('Products')} value={category.products_count} />
			</dl>
		</li>
	)
}
